import template from './categories-list.html';
import controller from './categories-list.controller';

let categoriesListComponent = {
  bindings: {},
  template,
  controller
};

export default categoriesListComponent;


// WEBPACK FOOTER //
// ./client/app/components/categories-faq/categories-list.component.js